import React, { ReactElement } from 'react';
import './style.css';

interface IProps {
  name: any;
  url: any;
  size?: 'medium' | 'large';
}

// The small thumbnail that displays within a library card.
export default function LibraryThumbnail({
  name,
  url,
  size = 'medium',
}: IProps): ReactElement {
  return (
    <img
      src={url}
      className="library-thumbnail rounded-lg"
      width={size === 'medium' ? 40 : 80}
      height={size === 'medium' ? 40 : 80}
      alt={name}
    />
  );
}
